/**
 * ZUS Leathers - Global JavaScript
 */

(function() {
  'use strict';

  // Utility
  const qs = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  // Debounce
  function debounce(fn, wait = 150) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  // ========== HEADER ==========
  const header = qs('.header');
  const headerWrapper = qs('.header-wrapper');
  if (header) {
    let lastScroll = 0;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 80) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      lastScroll = y;
    };
    window.addEventListener('scroll', debounce(onScroll, 10), { passive: true });
    onScroll();
  }

  // ========== MOBILE MENU ==========
  const menuToggle = qs('[data-menu-toggle]');
  const mobileMenu = qs('.mobile-menu');
  const menuClose = qs('[data-menu-close]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    if (menuClose) {
      menuClose.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
    // Nested submenus
    qsa('[data-submenu-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const submenu = btn.nextElementSibling;
        if (submenu) {
          submenu.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', submenu.classList.contains('is-open'));
        }
      });
    });
  }

  // ========== ANNOUNCEMENT SLIDER ==========
  const annSlides = qsa('.announcement-bar__slide');
  if (annSlides.length > 1) {
    let idx = 0;
    setInterval(() => {
      idx = (idx + 1) % annSlides.length;
      annSlides.forEach((s, i) => {
        s.style.transform = `translateX(-${idx * 100}%)`;
      });
    }, 4500);
  }

  // ========== BACK TO TOP ==========
  const backToTop = qs('.back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', debounce(() => {
      if (window.scrollY > 600) {
        backToTop.classList.add('is-visible');
        backToTop.hidden = false;
      } else {
        backToTop.classList.remove('is-visible');
      }
    }, 50), { passive: true });
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ========== FADE IN ANIMATIONS ==========
  if (window.theme && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    qsa('.fade-in').forEach(el => observer.observe(el));
  }

  // ========== SEARCH OVERLAY ==========
  const searchToggle = qs('[data-search-toggle]');
  const searchOverlay = qs('.search-overlay');
  const searchClose = qs('[data-search-close]');
  const searchInput = qs('.search-overlay__input');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => searchInput && searchInput.focus(), 100);
    });
    if (searchClose) {
      searchClose.addEventListener('click', () => {
        searchOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
    // Predictive search
    if (searchInput && window.theme) {
      searchInput.addEventListener('input', debounce(async (e) => {
        const q = e.target.value.trim();
        const resultsEl = qs('.search-overlay__results');
        if (!q || q.length < 2) {
          if (resultsEl) resultsEl.innerHTML = '';
          return;
        }
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
          const data = await res.json();
          if (resultsEl && data.resources && data.resources.results) {
            const products = data.resources.results.products || [];
            resultsEl.innerHTML = products.map(p => `
              <a href="${p.url}" class="search-result-item" style="display:flex;gap:1.2rem;padding:1.2rem 0;border-bottom:1px solid rgba(9,9,9,0.06);">
                <img src="${p.image || ''}" alt="" width="60" height="60" style="object-fit:contain;background:#f5f2eb;">
                <div>
                  <div style="font-size:1.4rem;">${p.title}</div>
                  <div style="font-size:1.3rem;color:rgba(9,9,9,0.5);">${p.price}</div>
                </div>
              </a>
            `).join('') || '<p style="padding:2rem;text-align:center;color:rgba(9,9,9,0.5);">No results found</p>';
          }
        } catch (err) {
          console.warn('Search error', err);
        }
      }, 280));
    }
  }

  // ========== ACCORDIONS ==========
  qsa('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.product-accordion, .faq-item, [data-accordion]');
      if (item) {
        const isOpen = item.classList.contains('is-open');
        // Optional: close siblings
        const parent = item.parentElement;
        if (parent && parent.dataset.accordionGroup) {
          qsa('.is-open', parent).forEach(el => {
            if (el !== item) el.classList.remove('is-open');
          });
        }
        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', !isOpen);
      }
    });
  });

  // ========== WISHLIST (localStorage) ==========
  const WISHLIST_KEY = 'zus_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch { return []; }
  }
  function saveWishlist(ids) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
  }
  function toggleWishlist(productId) {
    let list = getWishlist();
    const idx = list.indexOf(String(productId));
    if (idx > -1) list.splice(idx, 1);
    else list.push(String(productId));
    saveWishlist(list);
    return list.includes(String(productId));
  }
  function isInWishlist(productId) {
    return getWishlist().includes(String(productId));
  }

  // Init wishlist buttons
  qsa('[data-wishlist-toggle]').forEach(btn => {
    const id = btn.dataset.productId;
    if (isInWishlist(id)) btn.classList.add('is-active');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const active = toggleWishlist(id);
      btn.classList.toggle('is-active', active);
      // Update count if exists
      const countEl = qs('[data-wishlist-count]');
      if (countEl) countEl.textContent = getWishlist().length || '';
    });
  });

  // ========== RECENTLY VIEWED ==========
  const RV_KEY = 'zus_recently_viewed';
  function addRecentlyViewed(product) {
    try {
      let list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      list = list.filter(p => p.id !== product.id);
      list.unshift(product);
      list = list.slice(0, 12);
      localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch {}
  }
  // Expose for product page
  window.ZUS = window.ZUS || {};
  window.ZUS.addRecentlyViewed = addRecentlyViewed;
  window.ZUS.getRecentlyViewed = () => {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); }
    catch { return []; }
  };
  window.ZUS.toggleWishlist = toggleWishlist;
  window.ZUS.isInWishlist = isInWishlist;
  window.ZUS.getWishlist = getWishlist;

  // ========== QUANTITY SELECTORS ==========
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('[data-qty-input]');
    if (!input) return;
    let val = parseInt(input.value, 10) || 1;
    if (btn.dataset.qtyBtn === 'plus') val++;
    else if (btn.dataset.qtyBtn === 'minus' && val > 1) val--;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ========== SIZE GUIDE MODAL ==========
  qsa('[data-size-guide]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = qs('.size-guide-modal');
      if (modal) modal.classList.add('is-open');
    });
  });
  qsa('[data-size-guide-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      qs('.size-guide-modal')?.classList.remove('is-open');
    });
  });

})();
